import React, { useState } from 'react';
import IconInput from 'src/components/IconInput/IconInput';
import RadioModal from 'src/components/RadioModal/RadioModal';
import arrowDown from 'src/assets/arrowDown-3x.png';

interface Option {
  label: string;
}

interface YesNoSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options?: Option[];
  placeholder?: string;
  title?: string;
  testID?: string;
}

const defaultOptions: Option[] = [{ label: 'Yes' }, { label: 'No' }];

/**
 * A self-contained select (IconInput + RadioModal) that manages its own modal
 * visibility. Mirrors the exact IconInput/RadioModal pattern used across the
 * application screens so behavior is identical, but removes the per-field
 * visibility boilerplate. Defaults to a Yes/No option set.
 */
const YesNoSelect: React.FC<YesNoSelectProps> = ({
  label,
  value,
  onChange,
  options = defaultOptions,
  placeholder = 'Select an option',
  title,
  testID,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <IconInput
        label={label}
        testID={testID}
        value={value}
        placeholder={placeholder}
        onPress={() => setIsVisible(true)}
        iconSource={arrowDown}
        iconHeight={6.67}
        iconWidth={16.67}
      />
      <RadioModal
        testID={testID ? `${testID}-modal` : undefined}
        isVisible={isVisible}
        onSelectOption={onChange}
        onButtonClickLeft={() => setIsVisible(false)}
        onClose={() => setIsVisible(false)}
        title={title || label}
        options={options}
        selectedValue={value}
      />
    </>
  );
};

export default YesNoSelect;
